<template>
  <div class="submit-thseis-block">
    <div class="card-block">
      <el-alert
        v-if="!isLogin"
        :closable="false"
        show-icon
        title="友情提示 Important Notice"
        type="warning"
      >
        <div class="flex">
          <span
            >为更好地为您提供服务，请首先进行注册/登录，本系统仅登录用户方可提交信息，建议您先注册/登录再进行论文提交。</span
          >
          <span @click="toLogin" class="tel">立即登录 Login</span>
        </div>
      </el-alert>

      <div class="title">
        <img src="@/assets/imgs/icon24.png" />
        <span>联系信息</span>
        <div>为保证您报名的活动顺利完成，请务必填写真实信息</div>
        <el-button
          @click="toList"
          icon="el-icon-refresh-left"
          size="mini"
          type="primary"
          style="font-size: 14px; margin-left: 12px"
          >返回</el-button
        >
      </div>

      <el-form
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
        ref="ruleForm"
      >
        <el-form-item label="活动名称 Activity Name" prop="activity_name">
          <el-input
            placeholder="务必正确"
            v-model="ruleForm.activity_name"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="时间节点 Important Date" prop="activity_date">
          <el-input
            placeholder="务必正确"
            v-model="ruleForm.activity_date"
            disabled
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="活动介绍 Introduction" prop="activity_remarks">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="务必正确"
            v-model="ruleForm.activity_remarks"
            disabled
          ></el-input>
          <p v-if="ruleForm.activity_remarks.indexOf('http') == 0">
            <el-link
              type="primary"
              :href="ruleForm.activity_remarks"
              target="_blank"
              >链接跳转</el-link
            >
          </p>
        </el-form-item> -->
        <el-form-item label="姓名 Name" prop="user_name">
          <el-input
            placeholder="请输入真实中文姓名"
            v-model="ruleForm.user_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份 Identity" prop="user_identity">
          <el-select v-model="ruleForm.user_identity" placeholder="请选择">
            <el-option
              v-for="item in userIdentityOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话 Mobile" prop="user_mobile">
          <el-input
            placeholder="务必正确"
            v-model="ruleForm.user_mobile"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信 WeChat" prop="user_weixin">
          <el-input
            placeholder="务必正确，后续将据此与您联系"
            v-model="ruleForm.user_weixin"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱 Email" prop="user_email">
          <el-input
            placeholder="用于接收发票，务必正确"
            v-model="ruleForm.user_email"
          ></el-input>
          <p>*后续重要通知将发送至上述邮箱，建议您不做修改</p>
        </el-form-item>
        <!-- <el-form-item label="QQ号 QQ" prop="user_qq">
          <el-input
            placeholder="务必正确，后续将据此与您联系"
            v-model="ruleForm.user_qq"
          ></el-input>
        </el-form-item> -->

        <el-form-item label="" style="margin-bottom: 5px">
          <p class="color-blue">*如需报销请正确填下如下三项：</p>
        </el-form-item>
        <el-form-item
          label="单位名称 University or Institute"
          style="margin-top: 5px"
        >
          <el-input
            placeholder="用于开具发票，务必准确完整"
            v-model="ruleForm.user_company"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位税号 Tax No.">
          <el-input
            placeholder="即统一社会信用代码，务必正确"
            v-model="ruleForm.tax_no"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票类型 Invoice type">
          <el-select
            placeholder="开发票用，请务必保证准确"
            v-model="ruleForm.invoice_type"
          >
            <el-option label="会议注册费" value="会议注册费"></el-option>
            <el-option label="培训费" value="培训费"></el-option>
            <el-option
              label="其他（与客服联系）"
              value="其他（与客服联系）"
            ></el-option>
          </el-select>
          <p>请与导师或本单位财务负责人确认可报销的发票类型后再提交。</p>
        </el-form-item>
        <!-- <el-form-item
          label="其他发票类型"
          v-if="ruleForm.invoice_type == '其它（手工输入）'"
        >
          <el-input
            placeholder="其他发票类型"
            v-model="ruleForm.invoice_type_else"
          ></el-input>
          <p>如您选择了“其它”的发票类型，请在下面手工输入您需要的发票类型。</p>
        </el-form-item> -->

        <el-form-item label="论文附件">
          <p>
            请保留参考文献和图表供编辑参考（参考文献不计字数），可依次上传多个文件，单个文件大小不超过{{
              $store.state.user.maxFileName
            }}。
          </p>
          <!-- :on-change="handleChange" -->
          <el-upload
            :action="`${$store.state.user.urlLink}api/ajax_paper_file`"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList2"
            :on-error="handleError"
            :on-remove="handleRemove2"
            :on-success="handleSuccess2"
            class="upload-demo"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </el-form-item>

        <el-form-item label="付款凭证" prop="upload">
          <el-upload
            ref="uploadPaymentVoucher"
            :action="`${$store.state.user.urlLink}api/ajax_img`"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            accept=".jpg, .jpeg, .png"
            class="upload-payment-voucher"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div class="el-upload__tip" slot="tip">
              
            </div> -->
          </el-upload>
          <!-- is_inner 1内部活动 -->
          <div class="el-upload__tip">
            <h3 style="line-height: 1; margin: 0 0 10px 0">
              通过如下三种方式之一支付，并上传支付截图。金额参见会议通知或咨询会务老师。
            </h3>
            <div class="flex" style="justify-content: space-between">
              <div style="width: 48%">
                <p>
                  A.使用储蓄卡/信用卡/公务卡直接扫下码支付【方便快捷，推荐】
                </p>
                <img
                  style="width: 250px"
                  src="@/assets/imgs/bank-quankuan.png"
                />
              </div>

              <div style="width: 48%">
                <p>
                  B.无需发票报销者，享受9折报名优惠，请直接扫下方支付宝二维码支付【仅限自费参会者】
                </p>

                <img
                  style="width: 250px"
                  src="@/assets/imgs/alipay-geren.png"
                />
              </div>
            </div>

            <div>
              <p style="magirn: 0">
                C.先个人支付，拿到发票后办理对公汇款，退还个人支付部分【适用于要求必须对公汇款的单位】
                您可先用个人支付宝扫右上方二维码完成支付，收到我们提供的发票等报销材料后，您可在30天内通过对公汇款等形式缴费，收到汇款后我方将全额退还个人支付部分。对公汇款账号为：
                户名：北京文雅信达科技有限公司 开户行：招商银行北京金融街支行
                账号： 110936956910201
              </p>
            </div>

            <p style="margin-top: 10px">
              请上传jpg、png格式的付款凭证截图。上传的文件大小不能超{{
                $store.state.user.maxFileName
              }}。<span style="color: #f46c6c"
                >上传成功后请检查缩略图是否正常显示，若不正常，请重新上传！</span
              >
            </p>
          </div>
          <!-- <div class="el-upload__tip">
            <h3 style="line-height: 1; margin: 0 0 10px 0">
              支付方式详见活动通知或活动宣传推文（点击上方链接可达）
            </h3>
            <p style="margin-top: 10px">
              请上传jpg、png格式的付款凭证截图。上传的文件大小不能超{{
                $store.state.user.maxFileName
              }}。<span style="color: #f46c6c"
                >上传成功后请检查缩略图是否正常显示，若不正常，请重新上传！</span
              >
            </p>
          </div> -->
        </el-form-item>

        <el-form-item label="">
          <p>活动描述：{{ checkedInfo.pop_txt || '暂无' }}</p>
          <p v-if="checkedInfo.bill_url">
            <el-link type="primary" @click="downLoad(checkedInfo.bill_url)"
              >海报下载</el-link
            >
            <!-- <span @click="downLoad(checkedInfo.bill_url)">海报下载</span> -->
          </p>
        </el-form-item>

        <el-form-item label="填写过程中如有疑问可扫码加微信咨询">
          <img style="width: 200px" src="@/assets/imgs/teacher-sun.png" />
          <!-- <p></p> -->
        </el-form-item>

        <el-form-item label="推荐码（非必填）">
          <el-input
            placeholder="请在此输入推荐码"
            v-model="ruleForm.invited_code"
          ></el-input>
          <p>
            请输入推荐您参加本次活动的媒体（公众号）上所注明的随机推荐码，以获得相应积分奖励（积分可兑换礼品或现金）
          </p>
        </el-form-item>

        <el-form-item label="备注 Remarks">
          <el-input
            placeholder="请在此输入您的特殊需求，中英文均可。"
            type="textarea"
            v-model="ruleForm.user_remarks"
          ></el-input>
          <p>
            有必要说明的其他事项在此说明，如您从哪里（哪个公众号）看到的活动信息?
          </p>
        </el-form-item>
      </el-form>

      <el-alert
        :closable="false"
        show-icon
        title="重要提示 Important Notice"
        type="warning"
      >
        <div class="flex">
          <span>
            提交后，请根据推文中的联系方式联系会务老师或直接加入报名微信群。
          </span>
        </div>
      </el-alert>

      <div class="align-center">
        <el-button
          :loading="submitLoading"
          @click="submitForm('ruleForm')"
          type="primary"
          >信息确认无误，立即提交 SUBMIT</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 提交论文
 */
import * as _api from '@/api/user'
import * as commonFunc from '@/utils/common-func'

export default {
  name: 'SubmitJoinActivity',
  props: {
    // tags info
    checkedInfo: {
      type: Object,
      default: () => {
        return {
          pop_txt: ''
        }
      }
    }
  },
  data() {
    //验证手机号是否合法
    const validateTel = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('手机号不能为空'))
      } else {
        const telReg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (telReg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确手机号 Mobile'))
        }
      }
    }

    //验证邮箱是否合法
    const validateEmail = (rule, value, callback) => {
      // const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      const emailTrue = commonFunc.getCharCount(value, '@') == 1
      if (value == '') {
        return callback(new Error('邮箱不能为空'))
        // callback();
        // } else if (mailReg.test(value)) {
      } else if (emailTrue) {
        callback()
      } else {
        callback(new Error('请输入正确的邮箱格式 Email'))
      }
    }

    // 校验文件上传
    const uploadFile = (rule, value, callback) => {
      if (this.fileList.length === 0) {
        callback(new Error('请上传文件'))
      } else {
        callback()
      }
    }

    return {
      total: 0, // 订单总量
      submitLoading: false, // 提交按钮loading
      // 提交订单的参数
      ruleForm: {
        activity_name: '第六届全国定量遥感学术论坛', // 不提交
        activity_date: '2023-06-16至2023-06-18', // 不提交
        activity_remarks: '', // 不提交
        activity_id: '5', // 活动id
        user_name: '',
        user_mobile: '',
        user_company: '',
        user_identity: '', // 身份
        user_email: '',
        // user_qq: '',
        user_weixin: '',
        user_remarks: '',
        invited_code: '', // 推荐码
        tax_no: '',
        invoice_type: '',
        paper_url: '' // 文件附件
      },
      // 上传文件的列表
      fileList: [],
      fileList2: [],
      rules: {
        activity_name: [
          {
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        activity_date: [
          {
            required: true,
            message: '请输入时间节点 Important Date',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        activity_remarks: [
          {
            required: true,
            message: '请输入活动介绍 Introduction',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        user_name: [
          {
            required: true,
            message: '请输入姓名 Name',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        user_mobile: [
          {
            required: true,
            validator: validateTel,
            trigger: 'blur'
          }
        ],
        user_email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        // user_company: [
        //   {
        //     required: true,
        //     message: '请输入单位名称 University or Institute',
        //     trigger: 'blur'
        //   }
        // ],
        user_identity: [
          {
            required: true,
            message: '请选择身份 Identity',
            trigger: 'change'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        user_qq: [
          {
            required: true,
            message: '请输入QQ号 QQ',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        user_weixin: [
          {
            required: true,
            message: '请输入微信 WeChat',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        upload: [{ required: true, validator: uploadFile, trigger: 'blur' }]
      },
      isLogin: true, // 是否已经登陆
      userIdentityOptions: [
        {
          value: '本科生',
          label: '本科生'
        },
        {
          value: '硕士生',
          label: '硕士生'
        },
        {
          value: '博士生',
          label: '博士生'
        },
        {
          value: '教师',
          label: '教师'
        },
        {
          value: '企业人员',
          label: '企业人员'
        },
        {
          value: '其他',
          label: '其他'
        }
      ]
    }
  },
  // 计算属性
  computed: {
    userInfoWatch() {
      return this.$store.state.user.userName
    }
  },
  // 监听
  watch: {
    userInfoWatch(curVal, oldVal) {
      //这里的curVal就是需要监听的值
      this.ruleForm.user_name = curVal
      this.ruleForm.user_email = this.$store.state.user.userInfo
        ? this.$store.state.user.userInfo.email
        : ''
      this.ruleForm.user_mobile = this.$store.state.user.userInfo
        ? this.$store.state.user.userInfo.mobile
        : ''

      // this.getActivity() // 重新获取活动名称
    }
    // fileList2: {
    //   //深度监听，可监听到对象、数组的变化
    //   handler(val, oldVal) {
    //     localStorage.setItem('paper_polish_file', JSON.stringify(this.fileList2))
    //   },
    //   deep: true
    // }
  },
  mounted() {},
  created() {
    this.getOrderTotal() //获取订单总数
    // this.getActivity() // 获取活动名称

    // console.log('this.checkedInfo', this.checkedInfo)
    // this.ruleForm.activity_name = this.checkedInfo.activity_name
    // this.ruleForm.activity_id = this.checkedInfo.id
    // this.ruleForm.activity_date = this.checkedInfo.activity_date
    // this.ruleForm.activity_remarks = this.checkedInfo.activity_remarks

    if (
      !localStorage.getItem('userInfo') ||
      localStorage.getItem('userInfo') == 'null'
    ) {
      this.isLogin = false
      this.toLogin()
    }

    // 页面初始化载入用户信息
    this.ruleForm.user_name = this.$store.state.user.userInfo
      ? this.$store.state.user.userInfo.username
      : ''
    this.ruleForm.user_email = this.$store.state.user.userInfo
      ? this.$store.state.user.userInfo.email
      : ''
    this.ruleForm.user_mobile = this.$store.state.user.userInfo
      ? this.$store.state.user.userInfo.mobile
      : ''
  },
  methods: {
    /**
     * @description 前往活动列表
     */
    toList() {
      this.$router.push({
        path: '/conferences'
      })
    },

    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      _api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data

          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    // /**
    //  * @description 获取活动名称
    //  */
    // getActivity() {
    //   const _this = this
    //   const _param = {}
    //   _api
    //     .getActivity(_param)
    //     .then((res) => {
    //       const _data = res.data
    //       _this.ruleForm.activity_name = _data.activity_name
    //       _this.ruleForm.activity_id = _data.activity_id
    //       _this.ruleForm.activity_date = _data.activity_date
    //       _this.ruleForm.activity_remarks = _data.activity_remarks

    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       // _this.$message.error('操作失败，请稍后刷新页面再试！')
    //     })
    // },

    /**
     * @description 注册提交
     */
    submitForm(formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.submitLoading = true
          const _param = JSON.parse(JSON.stringify(this.ruleForm))

          // 付款凭证
          _param.pay_img = ''
          _this.fileList.map((item) => {
            _param.pay_img = _param.pay_img + ',' + item.response.data
          })
          _param.pay_img = _param.pay_img.substring(1)

          // 论文附件
          _param.paper_url = ''
          _this.fileList2.map((item) => {
            _param.paper_url = _param.paper_url + ',' + item.response.data
          })
          _param.paper_url = _param.paper_url.substring(1)

          _api
            .takeActivity(_param)
            .then((res) => {
              _this.submitLoading = false
              _this.$message.success(
                '已收到您的报名信息，审核通过后将发送邮件通知，您可进入导航栏个人中心中的订单列表查看本次活动的参会秘钥，发票将在72h内发送至您的邮箱。'
              )
              _this.$router.push({
                path: '/order?activeName=activity'
              })
            })
            .catch((err) => {
              _this.submitLoading = false
              console.log(err)
              if (err == 'Error: 您已预报名成功，请留意后续邮件通知！') {
                _this.$message.closeAll()
                _this.$message.success(
                  '已收到您的报名信息，审核通过后将发送邮件通知，您可进入导航栏个人中心中的订单列表查看本次活动的参会秘钥，发票将在72h内发送至您的邮箱。'
                )
                _this.$router.push({
                  path: '/order?activeName=activity'
                })
              }
              if (err == 'Error: 请登录') {
                setTimeout(() => {
                  _this.toLogin() // 注册、登陆
                }, 500)
              }
            })
        } else {
          _this.$message.error('请根据系统提示将必填信息填写完整，再进行提交。')
          console.log('error submit!!')
          return false
        }
      })
    },

    /**
     * @description 论文附件上传成功的钩子函数
     */
    handleSuccess2(response, file, fileList) {
      if (response.error_msg == '请登录') {
        this.$message.error('登录之后，才能允许上传文件，请先登录！')
        this.fileList2 = []
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      } else if (response.error_code == 1) {
        this.$message.error(response.error_msg)
        this.fileList2 = []
      } else {
        this.fileList2 = fileList.slice(-10) // 最大10个文件
      }
    },

    /**
     * @description 删除论文附件文件
     */
    handleRemove2(file, fileList) {
      this.fileList2 = fileList
    },


    /**
     * @description 限制上传文件的大小
     */
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isOverSize =
        file.size / 1024 / 1024 <= this.$store.state.user.maxFile

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isOverSize) {
        this.$message.error(
          `上传的文件大小不能超过${this.$store.state.user.maxFileName}!`
        )
      }
      return isOverSize
    },

    /**
     * @description 上传失败的钩子函数
     */
    handleError(err, file, fileList) {
      // this.$message.error('上传失败，请再次尝试！')
      this.$message.error(err.error_msg)
    },

    /**
     * @description 上传成功的钩子函数
     */
    handleSuccess(response, file, fileList) {
      // 只保留一张图片
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.$refs.uploadPaymentVoucher.clearFiles()
      this.fileList = []
      if (response.error_msg == '请登录') {
        this.$message.error('登录之后，才能允许上传文件，请先登录！')
        this.fileList = []
        // setTimeout(() => {
        //   this.toLogin()
        // }, 1000)
      } else if (response.error_code == 1) {
        // this.$message.error('上传失败，请重新再试')
        this.$message.error(response.error_msg)
        this.fileList = []
      } else {
        this.fileList = fileList.slice(-10) // 最大10个文件
      }
    },

    /**
     * @description 删除文件
     */
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    /**
     * @description 点击去登录
     */
    toLogin() {
      this.$store.dispatch('user/toLogin', { toggle: true })
    },

    /**
     * @description 附件下载
     */
    downLoad(row) {
      // http匹配http，https匹配https
      let url = row
      this.downloadIamge(url, row.split('/')[row.split('/').length - 1])
      // if (this.isImg(row)) {
      //   this.downloadIamge(url, 'row.fileName')
      // } else if (this.isPdf(row)) {
      //   this.toBobDownload(row)
      // } else if (this.isTxt(row)) {
      //   this.toBobDownload(row)
      // } else if (this.isVideo(row)) {
      //   this.toBobDownload(row)
      // } else {
      //   window.open(url)
      // }
    },
    /**
     * @description txt、video、pdf下载
     */
    toBobDownload(row) {
      let xhr = new XMLHttpRequest()

      let url = row
      xhr.open('get', url, true)
      // xhr.setRequestHeader('Content-type', 'text/plain;charset=utf-8')
      xhr.responseType = 'blob'
      let that = this
      xhr.onload = function () {
        if (this.status == 200) {
          const blob = this.response
          that.downloadFile(blob, 'row.fileName')
        }
      }
      xhr.send()
    },
    downloadFile(blob, name) {
      let a = document.createElement('a')
      let href = blob
      if (typeof blob == 'string') {
        a.target = '_blank'
      } else {
        href = window.URL.createObjectURL(blob)
      }
      a.href = href
      a.download = name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      if (typeof blob != 'string') {
        window.URL.revokeObjectURL(href)
      }
    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      const image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/png') //得到图片的base64编码数据

        const a = document.createElement('a') // 生成一个a元素
        const event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    isImg(row) {
      let reg = /(jpeg|JPEG|jpg|JPG|png|PNG)$/
      console.log('reg.test(row.fileType)', reg.test(row.fileType))
      return reg.test(row.fileType)
    },
    isPdf(row) {
      let reg = /(pdf|PDF)$/
      return reg.test(row.fileType)
    },
    isTxt(row) {
      let reg = /(txt|TXT)$/
      return reg.test(row.fileType)
    },
    isVideo(row) {
      let reg =
        /(avi|AVI|wmv|WMV|mpg|MPG|mpeg|MPEG|mov|MOV|rm|RM|ram|RAM|swf|SWF|flv|FLV|mp4|MP4)$/
      return reg.test(row.fileType)
    }
  }
}
</script>
<style lang="scss" scoped>
.submit-thseis-block {
  width: 1285px;
  margin: 50px auto 0 auto;

  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 0 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }

      & > div {
        font-size: 14px;
        color: #98a5a6;
        margin: 0 0 0 10px;
        flex-grow: 1; /* default 0 */
      }

      a {
        text-decoration: underline;
      }
    }

    /deep/.el-form {
      // margin: 50px 200px;

      .el-form-item {
        padding: 0 200px;
        margin: 30px 0;
      }

      // .el-button {
      //   margin: 100px 0 0 0;
      //   width: 550px;
      // }

      .el-form-item__label {
        padding-bottom: 0;
      }

      .el-select {
        width: 100%;
      }

      .flex {
        display: flex;
        justify-content: space-around;
      }

      .upload-payment-voucher .el-upload {
        text-align: left;
      }

      .alipay {
        h4 {
          text-align: center;
          font-size: 14px;
          color: #606266;
          margin: 0 0 10px 0;
          font-weight: normal;
        }

        img {
          display: block;
          width: 140px;
          margin: 0 auto;
        }
      }

      p {
        margin: 0;
        line-height: 1.5;
      }

      a {
        color: $colorNormal;
      }

      .agreement {
        color: $colorNormal;
        cursor: pointer;
      }

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #606266;
      }

      .color-red {
        color: #f46c6c;
        margin-right: 4px;
      }
    }

    .align-center {
      text-align: center;

      .el-button {
        width: 500px;
        height: 70px;
        font-size: 22px;
      }
    }
  }

  /deep/.el-alert {
    margin: 0 0 15px 0;
    .el-alert__content {
      width: 100%;
    }

    .el-alert__title {
      font-size: 16px;
    }

    .flex {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .tel {
      cursor: pointer;
      display: inline-block;
      width: 180px;
      height: 36px;
      line-height: 36px;
      border-radius: 3px;
      text-align: center;
      color: #ffffff;
      background: #ea870f;
      margin-top: -20px;
    }
  }
}
</style>